import { decodePolyline } from '../utils/polylineDecoder';

const OSRM_BASE_URL = process.env.REACT_APP_OSRM_URL || 'https://router.project-osrm.org/route/v1/driving';

/**
 * Obtém rota entre múltiplos pontos usando OSRM
 * @param {Array} coordinates - Array de {latitude, longitude}
 * @returns {Array} Array de [lat, lng] para desenhar polyline
 */
export async function getRouteGeometry(coordinates) {
  if (!coordinates || coordinates.length < 2) {
    return [];
  }

  // OSRM usa lon,lat
  const waypoints = coordinates
    .map(c => `${c.longitude},${c.latitude}`)
    .join(';');

  const url = `${OSRM_BASE_URL}/${waypoints}?overview=full`;

  try {
    const response = await fetch(url);
    const data = await response.json();

    if (data.code === 'Ok' && data.routes?.[0]?.geometry) {
      return decodePolyline(data.routes[0].geometry);
    }
    return [];
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('OSRM error:', error);
    }
    return [];
  }
}

